// src/firebase-config.js
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
    //   apiKey: "YOUR_API_KEY",
    //   authDomain: "YOUR_AUTH_DOMAIN",
    //   projectId: "YOUR_PROJECT_ID",
    //   storageBucket: "YOUR_STORAGE_BUCKET",
    //   messagingSenderId: "YOUR_MESSAGING_SENDER_ID",
    //   appId: "YOUR_APP_ID",
    //   measurementId: "YOUR_MEASUREMENT_ID"

    //   apiKey: "AIzaSyB4lskbCBOh-Mk9cDKsYp9Xz_WW2vBDkNo",
    //   authDomain: "daqi-47432.firebaseapp.com",
    //   projectId: "daqi-47432",
    //   storageBucket: "daqi-47432.firebasestorage.app",
    //   messagingSenderId: "673461861012",
    //   appId: "1:673461861012:web:6694aa8dd504634412d281",
    //   measurementId: "G-41DCRZ8MZ2"
    apiKey: "AIzaSyDVEl9AutCrMcVuQEeGZpktee0OR9eP7Vg",
    authDomain: "daqi-anchors.firebaseapp.com",
    projectId: "daqi-anchors",
    storageBucket: "daqi-anchors.firebasestorage.app",
    messagingSenderId: "240233215461",
    appId: "1:240233215461:web:17752813ea9bb3d7c2ab0c",
    measurementId: "G-SP47FR4EEZ"
};

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

export const requestForToken = () => {
    return getToken(messaging, { vapidKey: 'BB6fCPGd4Lyhbhb9f-RMAgv7810hZIW8aDkEiuWrPkA2K5FxARPFTvCcqWZrTawGckJCcuIuVqPHHAwCHhxeqGU' })
        .then((currentToken) => {
            if (currentToken) {
                console.log('Client token:', currentToken);
                localStorage.setItem('fcmToken', currentToken);
            } else {
                console.warn('No registration token available. Request permission.');
            }
        })
        .catch((err) => {
            console.error('An error occurred while retrieving token. ', err);
        });
};

export const onMessageListener = () =>
    new Promise((resolve) => {
        onMessage(messaging, (payload) => {
            resolve(payload);
        });
    });
